export const ItemTypes = {
	ROSTER: 'roster',
	LINEUP: 'lineup',
	BENCH: 'bench',
	COURT: 'court'
};
